import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";
import { PasswordResetRequest } from "lib/data/model";

export class PasswordApi {

	public static requestPasswordReset = async (username: string): Promise<boolean> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Password/Reset`;

			// Make Request
			const response: Response = await Http.httpPost(url, username);

			// Check Response
			return response.ok;

			// TODO: Handle Errors
		}

		// Return Nothing
		return false;
	}

	public static getPasswordResetToken = async (token: string): Promise<PasswordResetRequest | undefined> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Password/Reset/${token}`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const requirement: PasswordResetRequest = await ApiHelper.parseResponseBody(response);

				return requirement;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static resetPassword = async (password: string, token: string): Promise<boolean> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/Password/Reset/${token}`;

			// Make Request
			const response: Response = await Http.httpPost(url, password);

			// Check Response
			return response.ok;

			// TODO: Handle Errors
		}

		// Return Nothing
		return false;
	}
}
